<template>
  <b-container>
    <Headline title="Digital downloads" />

    <b-row>
      <b-col>
        <b-table :items="items" :fields="fields" class="sb-table table-responsive-md">
          <template slot="title" slot-scope="data">
            <router-link class="link" :to="{name: 'video-detail', params: {id: data.item.song.id}}">{{ data.item.song.title }}</router-link>
          </template>
          <template slot="album" slot-scope="data">
            <router-link class="link" :to="{name: 'album-detail', params: {id: data.item.album.id}}" v-if="data.item.album">{{ data.item.album.title }}</router-link>
            <span v-else>-</span>
          </template>
          <template slot="artist" slot-scope="data">
            <router-link class="link" :to="{name: 'artist-about', params: {artistId: data.item.artist.id}}">{{ data.item.artist.name }}</router-link>
          </template>
          <template slot="dl" slot-scope="data">
            <b-button class="btn-secondary dl" size="sm" @click="download(data.item)">
              <i class="sl-icon-cloud-download" />
              Download
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .container {
    margin-top: 1em;
  }

  .sb-table .link {
    color: $white;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  button.dl {
    padding-left: 1em;
    padding-right: 1.2em;
    background: $darkish-pink;
    border: $dark-pink;
  }

  button i.sl-icon-cloud-download {
    margin-right: 0.5em;
  }
</style>

<script>
import moment from '@/utils/moment'
import map from 'lodash/map'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Headline from '@/components/widgets/Headline'

export default {
  name: 'Downloads',
  components: {
    FontAwesomeIcon,
    Headline
  },
  data () {
    return {
      fields: [
        {
          key: 'title',
          label: 'Title',
          class: 'text-center'
        },
        {
          key: 'album',
          label: 'Album',
          class: 'text-center'
        },
        {
          key: 'artist',
          label: 'Artist',
          class: 'text-center'
        },
        {
          key: 'date',
          label: 'Purchased',
          class: 'text-center'
        },
        {
          key: 'dl',
          label: 'Actions',
          class: 'text-center'
        }
      ],
      items: []
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.items = map(await this.$store.dispatch('song/refreshSongsWithAccess'), acc => {
        return {
          artist: acc.song.artist,
          album: acc.album,
          song: acc.song,
          date: moment.utc(new Date(acc.created_at)).fromNow(),
          dl: acc.download_url
        }
      })
    },
    async download (item) {
      window.location = item.dl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/Downloads.vue